import {css} from 'styled-components';

// The single raised-surface elevation for the ticketing tree.
//
// Prefer composing a design-system surface that owns its own elevation — `Modal`,
// `DropdownList`, `PopoverHandler` — over reaching for this. It exists only for a
// custom raised surface that is genuinely none of those (a bespoke popover panel,
// a floating menu the design system does not yet cover), so that such surfaces
// share one value instead of each inventing their own.
//
// The value comes from the design system's elevation scale and falls back to the
// scale's mid step when a theme has not supplied one, so a missing token degrades
// to a flat surface rather than a crash.
export const raisedSurfaceShadow = css`
	box-shadow: ${p => p.theme.sys.elevation?.shadow?.['2'] ?? 'none'};
`;
